import { Component, OnInit, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';
import { ApiServiceService } from '../../services/common/api-service.service';

@Component({
  selector: 'app-merchant-layout',
  templateUrl: './merchant-layout.component.html',
  styleUrls: ['./merchant-layout.component.scss']
})
export class MerchantLayoutComponent implements OnInit, OnDestroy {

  unreadEnquiriesCount: number = 0;

  isSidebarOpen: boolean = false;

  private pollInterval: any;

  constructor(
    private router: Router,
    private apiService: ApiServiceService
  ) {}

  ngOnInit() {
    this.fetchUnreadEnquiries();

    this.pollInterval = setInterval(() => {
      this.fetchUnreadEnquiries();
    }, 10000);
  }

  ngOnDestroy() {
    if (this.pollInterval) {
      clearInterval(this.pollInterval);
    }
  }

  toggleSidebar(): void {
    this.isSidebarOpen = !this.isSidebarOpen;
  }

  closeSidebar(): void {
    this.isSidebarOpen = false;
  }

  fetchUnreadEnquiries() {
    const merchantId = localStorage.getItem('merchantId');

    if (merchantId) {

      this.apiService.getMerchantEnquiries(merchantId).subscribe({

        next: (res: any) => {

          if (res && res.data) {

            this.unreadEnquiriesCount =
              res.data.reduce(
                (acc: number, curr: any) =>
                  acc + (curr.merchant_unread_count || 0),
                0
              );

          }

        },

        error: (err) =>
          console.error(
            'Failed to fetch enquiries count:',
            err
          )

      });

    }
  }

  logout() {

    localStorage.removeItem('merchantToken');
    localStorage.removeItem('merchantId');
    localStorage.removeItem('merchantName');

    this.router.navigate([
      '/merchant/login'
    ]);

  }

}